<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Billing History'"
      [class]="extraClass"
      [canGoBack]="!cantGoBack"
      [customBack]="backPage" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (loaded) {
      @if (hasPrivatePro) {
        <tidy-row [align]="'center'">
          <tidy-filter
            [initValue]="proFilterValue"
            [items]="proFilterItems"
            [fitContent]="true"
            [newValue]="proFilterValue"
            (optionChange)="changePro($event)"
            class="align-center"/>
        </tidy-row>
      }
      @if (billingLoaded) {
        @if (showBilling && !hasProSelected) {
          <tidy-row [align]="windowService.isDesktopRes ? 'left' : 'center'">
            <tidy-text
              [body]="'Note: Your payment settings may require credit to reserve appointments, check the Account section for details. '" />
            @if (billingData.total_refundable === 0) {
              <tidy-text
                [body]="'You have no refundable credit.'" />
            }
            @if (billingData.total_refundable !== 0) {
              <tidy-text
                [body]="'<b>' + (billingData?.total_refundable | tcurrency) + '</b>'" />
                <tidy-text
                  [body]="' of your credit is refundable if you do not use it.'" />
              }
            </tidy-row>
          }
          @if (hasProSelected) {
            <tidy-row [align]="'center'">
              <tidy-text
                [body]="'This is '" />
              <tidy-text
                [body]="selectedProName"
                [translate]="false" />
              <tidy-text
                [body]="'\'s billing history with you. It only includes billing items that relate to them.'" />
            </tidy-row>
          }
          @if (userRole !== 'member') {
            <tidy-card>
              <tidy-row class="extra-bottom-padding">
                <tidy-text
                  [header]="'Current Credit: '" />
                @if (!hasProSelected) {
                  <tidy-text
                    [header]="billingData?.balance | tcurrency" />
                }
                @if (hasProSelected) {
                  <tidy-text
                    [header]="billingData?.credit_balance | tcurrency" />
                }
              </tidy-row>
              @for (detail of billingData?.balance_details; track detail) {
                <tidy-row class="vertical-align-middle">
                  @if (detail?.credit_type === 'credit') {
                    <tidy-image
                      [src]="'assets/img/coupon.svg'"
                      class="header-size" />
                  }
                  @if (detail?.credit_type === null || detail?.credit_type === 'charge') {
                    <tidy-image
                      [src]="'assets/img/credit-card.svg'"
                      class="header-size" />
                  }
                  @if (!detail?.transferred_from) {
                    <tidy-text
                      [body]="detail?.label" />
                  }
                  @if (detail?.transferred_from) {
                    <tidy-text
                [body]="(detail?.amount_left | tcurrency) + (' left from ' | translate) + (detail?.amount | tcurrency) + (' credit added by ' | translate)" />
                    <tidy-text
                      [body]="detail?.transferred_from?.account_name"
                      [translate]="false" />
                  }
                </tidy-row>
              }
              @if (totalPendingCharges !== 0) {
                <tidy-row class="extra-bottom-padding" [class.extra-top-padding]="billingData?.balance_details?.length > 0">
                  <tidy-divider />
                </tidy-row>
                <tidy-row class="vertical-align-center extra-bottom-padding">
                  <tidy-text
                    [header]="('Pending Credit: ' | translate) + (totalPendingCharges | tcurrency)" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="'The credit you loaded will be added to your account once the charges are completed.'" />
                </tidy-row>
              }
            </tidy-card>
          }
          @if (showBilling) {
            <tidy-row [align]="'center'">
              <tidy-filter
                [initValue]="0"
                [items]="addressFilter"
                [fitContent]="true"
                (optionChange)="changeAddress($event)" />
            </tidy-row>
          }
          @if (!chargesLoaded) {
            <div style="display: flex; justify-content: center; width: 100%;">
              <tidy-loader />
            </div>
          }
          @if (chargesLoaded) {
            @for (item of billingHistory; track item; let index = $index) {
              <tidy-card>
                @if (item?.isPendingClientCharge) {
                  <ion-chip [class]="item?.class">
                    <ion-icon [name]="item?.icon" />
                    <ion-label>{{ item?.status | titlecase }}</ion-label>
                  </ion-chip>
                  <tidy-row [alignLastItemRight]="true">
                    <tidy-text
                      style="margin-right:5px"
                      [header]="(item?.amount | tcurrency) + ' ' + (item?.payment_method?.type === 'card' ? (' charge' | translate) : (' debit' | translate))" />
                    <tidy-image
                      style="margin-left: 5px; cursor: pointer"
                      (action)="goToBillingItemHelp(item)"
                      [src]="'assets/svg/help-circle-outline.svg'"
                      class="header-size" />
                    <tidy-text
                      [body]="item?.formattedDate" />
                  </tidy-row>
                  <tidy-row class="vertical-align-center">
                    @if (item?.payment_method?.type === 'card') {
                      <tidy-text
                        [body]="('Card ending in ' | translate) + item?.payment_method?.metadata?.last4" />
                      @if (item?.payment_method?.is_primary) {
                        <tidy-text
                          [header]="'(primary)'"
                          style="margin-left: 5px" />
                      }
                    }
                    @if (item?.payment_method?.type === 'us_bank_account') {
                      <tidy-text
                        [body]="item?.payment_method?.metadata?.last4 ? (('Bank account ending in ' | translate) + (item?.payment_method?.metadata?.last4 | translate)) : 'Bank account'" />
                    }
                  </tidy-row>
                  @if (item?.payment_method?.metadata?.bank_name) {
                    <tidy-row>
                      <tidy-text
                        [body]="item?.payment_method?.metadata?.bank_name + (item?.payment_method?.metadata?.account_type ? ' | ' + (item?.payment_method?.metadata?.account_type | translate) : '')" />
                    </tidy-row>
                  }
                }
                @if (!item?.isPendingClientCharge) {
                  <tidy-row [alignLastItemRight]="true" [ngClass]="item?.refund_type ? '' : 'extra-bottom-padding'">
                    <tidy-text
                      style="margin-right:5px"
                      [header]="(item?.amount | tcurrency) + ' '" />
                    @if (item?.credit_type === 'credit') {
                      <tidy-text
                        [body]="'credit'" />
                    }
                    @if (item?.payment_method?.type === 'card' && item?.added_by !== 'concierge') {
                      <tidy-text
                        [body]="('charge on card ' | translate) + item?.payment_method?.metadata?.last4 || item?.last4" />
                    }
                    @if (item?.payment_method?.type === 'card' && item?.added_by === 'concierge') {
                      <tidy-text
                        [body]="('credit from card ' | translate) + item?.payment_method?.metadata?.last4 || item?.last4" />
                    }
                    @if (item?.payment_method?.type === 'us_bank_account') {
                      <tidy-text
                        [body]="('credit from account ' | translate) + item?.payment_method?.metadata?.last4 || item?.last4" />
                    }
                    @if (!hasProSelected && item?.credit_type !== 'credit') {
                      <tidy-image
                        style="margin-left: 5px; cursor: pointer"
                        (action)="goToBillingItemHelp(item)"
                        [src]="'assets/svg/help-circle-outline.svg'"
                        class="header-size" />
                    }
                    <tidy-text
                      [body]="item?.date | parseDateTime: 'MMM d'" />
                  </tidy-row>
                  @if (item?.refund_type) {
                    <tidy-row class="extra-bottom-padding">
                      <tidy-text
                        [actionBody]="item?.refund_type"
                        class="green" />
                    </tidy-row>
                  }
                  @if (item?.added_by === 'cleaning' && item?.credit_type === 'credit') {
                    <tidy-row [ngClass]="{'extra-bottom-padding': item?.details?.length > 0}">
                      <tidy-text
                        [body]="'Added from job on '" /><span>&nbsp;</span>
                      <tidy-text
                        [actionBody]="item?.source_cleaning_date | parseDateTime: 'MMM d'"
                        (action)="goToCleaningDetails(item?.source_cleaning_id)"
                        class="link" />
                    </tidy-row>
                  }
                  @if (item?.added_by !== 'cleaning' && item?.credit_type === 'credit') {
                    <tidy-row [ngClass]="{'extra-bottom-padding': item?.details?.length > 0}">
                      <tidy-text
                        [body]="'Added by '" /><span>&nbsp;</span>
                      <tidy-text
                        [body]="item?.from_credit_type_name"
                        [translate]="false" />
                    </tidy-row>
                  }
                  @for (detail of item?.details; track detail; let i = $index; let last = $last) {
                    <tidy-row [ngClass]="{'extra-bottom-padding': !last}">
                      @if (detail?.debit_type !== 'refund') {
                        <tidy-text
                          [body]="detail?.amount_used | tcurrency" />
                      }
                      @if (detail?.debit_type !== 'refund') {
                        <tidy-text
                          [body]="' used from '" />
                        @if (item?.payment_method?.type == 'card') {
                          <tidy-text
                            [body]="('card ending in ' | translate) + item?.last4 || '000'"/>
                        } @else if (item?.payment_method?.type == 'us_bank_account') {
                          <tidy-text
                            [body]="('bank account' | translate) + (item?.last4 ? (' ending in ' | translate) + (item?.last4 | translate) : '')"/>
                        } @else if (!item?.payment_method) {
                          <tidy-text
                            body="{{item?.from_credit_type_name}} credit"/>
                        }
                      }
                      @if (detail?.debit_type !== 'refund' && detail?.debit_source_billable_type !== 'Infrastructure::Models::Plan::SubscriptionInvoice') {
                        @if (detail?.text_for_customer) {
                          <tidy-text
                            [body]="' for '" /><span>&nbsp;</span>
                          <tidy-text
                            [body]="detail?.text_for_customer"
                            [translate]="false" />
                        }
                        @if (!detail?.text_for_customer && detail.debit_fee) {
                          <tidy-text
                            [body]="' by a '"/><span>&nbsp;</span>
                          <tidy-text
                            [body]="detail?.debit_fee.fee_percentage"/>
                          @if (detail?.feeLeviedOnName) {
                            <tidy-text
                              [body]="'% payment processing fee on '"/>
                            <tidy-text
                              [body]="detail?.feeLeviedOnName"
                              [translate]="false" />
                          } @else {
                            <tidy-text
                              [body]="'% payment processing fee'"/>
                          }
                        }
                        @if (!detail?.text_for_customer && !detail.debit_fee) {
                          @if (!detail?.transferred_to) {
                            <tidy-text
                              [body]="' by a '" /><span>&nbsp;</span>
                            <tidy-text
                              [body]="detail?.cleaning_state | formatState" />
                            <tidy-text
                              [body]="' job on '" /><span>&nbsp;</span>
                            <tidy-text
                              [actionBody]="detail?.cleaning_date | parseDateTime: 'MMM d'"
                              (action)="goToCleaningDetails(detail?.cleaning_id)"
                              class="link" />
                          }
                          @if (detail?.address_id) {
                            <tidy-text
                              body=" at " /><span>&nbsp;</span>
                            <tidy-text
                              [body]="addressesIndexedById[detail?.address_id]?.address_name || addressesIndexedById[detail?.address_id]?.address1" />
                          }
                          @if (detail?.transferred_to) {
                            <tidy-text
                              [body]="' by '" /><span>&nbsp;</span>
                            <tidy-text
                              [body]="detail?.transferred_to?.team?.name"
                              (action)="changePro(detail?.transferred_to?.team?.owner_id)"
                              class="link"
                              [translate]="false" />
                          }
                        }
                      }
                      @if (detail?.debit_source_billable_type === 'Infrastructure::Models::Plan::SubscriptionInvoice') {
                        @if (detail?.debit_fee?.type === 'cleaning_completed_fee') {
                          <tidy-text
                            [body]="' by a '" /><span>&nbsp;</span>
                          <tidy-text
                            [body]="detail?.debit_fee?.fee_percentage" />
                          @if (detail?.cleaning_date) {
                            <tidy-text
                              [body]="'% job fee for the '" /><span>&nbsp;</span>
                            <tidy-text
                              [body]="detail?.cleaning_state | formatState" />
                            <tidy-text
                              [body]="' job on '" /><span>&nbsp;</span>
                            <tidy-text
                              [actionBody]="detail?.cleaning_date | parseDateTime: 'MMM d'"
                              (action)="goToCleaningDetails(detail?.cleaning_id)"
                              class="link" />
                          } @else {
                            <tidy-text
                              [body]="'% job fee'" />
                          }
                        } @else {
                          <tidy-text
                            [body]="' for '" /><span>&nbsp;</span>
                          <tidy-text
                            [actionBody]="'your subscription'"
                            (action)="goToSubscriptionPage()"
                            class="link" />
                          @if (detail?.text_for_customer) {
                            <span>&nbsp;</span>
                            <tidy-text
                              [body]="'(' + detail?.text_for_customer + ')'"
                              [translate]="false" />
                          }
                        }
                      }
                      @if (detail?.debit_type === 'debit' && (detail?.cleaning_state === 'cancelled' || detail?.cleaning_state === 'cancelled_once') && detail?.booking_id !== null) {
                        <span>&nbsp;</span>
                        <tidy-text
                          [actionBody]="'Waive Fee'"
                          (action)="waiveFee(detail?.booking_id)"
                          class="link" />
                      }
                      @if (detail?.debit_type === 'refund') {
                        <tidy-text
                          [body]="detail?.amount_used | tcurrency" /><span>&nbsp;</span>
                        <tidy-text
                          [body]="' refunded. '" /><span>&nbsp;</span>
                        <tidy-text
                          [actionBody]="'Where is my refund?'"
                          (action)="learnAboutRefund()"
                          class="link" />
                      }
                    </tidy-row>
                  }
                }
              </tidy-card>
            }
            <tidy-row [align]="'center'">
              @if (!hasProSelected) {
                <tidy-text
                  [body]="'More history unavailable - Please contact us in the Concierge section for support.'" />
              }
              @if (hasProSelected) {
                <tidy-text
                  [body]="'More history unavailable - Please contact your pro for support.'" />
              }
            </tidy-row>
          }
        }
      }
    </tidy-wrapper>
  </ng-template>

  @if (!isRightSideContent) {
    <app-scroll-wrapper [templateContent]="content" />
  }

  @if (isRightSideContent) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
